import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams, useNavigate } from "react-router-dom"
import { enqueueSnackbar } from 'notistack'

import { AppContext } from '/providers/app-context'
import { getScanReportScans } from '/providers/templates-api'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-stats'
import Menu from '/components/templates/template-nav-menu'
import ReportTable from '../components/templates/scan-report-scans-table'
import moment from 'moment-timezone'

const TemplateScanReports = () => {

  const navigate = useNavigate()

  const { templateId, ts } = useParams()
  const { apiSource,apiKeys,loadingTemplates, templates } = useContext(AppContext)

  const [scans,setScans] = useState([])
  const [loading, setLoading] = useState(true)

  const template = useMemo(() => {return templates.filter(t => t.id === templateId)[0]}, [templates, templateId])

  const dateString = moment(ts,"YYYYMMDD").format("DD MMM YYYY")

  useEffect(() => {
    if(!loadingTemplates && !template) navigate("/templates")
    getScanReportDateData()
  },[template])
  
  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""} (${dateString})` : "",[template])

  const getScanReportDateData = async () => {
    const d = await getScanReportScans({apiSource,apiKeys,templateId,ts})
    
    if (d.error) {
      enqueueSnackbar({ message: d.error, variant: 'error' })
    } else {
      setScans(d.scans)
      setLoading(false)
    }
    setLoading(false)
  }

  return (
    <PageWrapper title={`Daily Scan Reports ${dateString}`} HelpText={HelpText} heading={heading} menu={<Menu template={template} />}>
      <ReportTable templateId={templateId} pass_type_id={template?.pass_type_id} scans={scans} loading={loading}/>
    </PageWrapper>
  )
}

export default TemplateScanReports
